import routes from "./routes"
import VueRouter from "vue-router"
import Vue from "vue"

Vue.use(VueRouter)

const router = new VueRouter({
    mode: "history",
    routes,
})

import store from "@/store"

router.beforeEach(async (to, from, next) => {
    if (!store.state.auth.authInitialized) {
        await store.dispatch("auth/initAuth")
        store.dispatch("auth/detectTenant")
    }

    const isAuthenticated = store.getters["auth/authenticated"]
    const publicPaths = ["/", "/forgot-password", "/reset-password", "/login"]

    if (!isAuthenticated && !publicPaths.includes(to.path)) {
        return next("/")
    }

    if (isAuthenticated && (to.path === "/" || to.path === "/login")) {
        return next("/dashboard")
    }

    next()
})

export default router
